export default __webpack_public_path__ + "static/media/gold_star.6293ae81.png";